// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pager_pager__Np5BR {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.Pager_btn__14gTK {
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  border: none;
  background: transparent;
  color: var(--dylo-text);
  font-family: var(--font-sans);
  font-size: 13px;
  border-radius: 7px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.12s ease, color 0.12s ease;
}
.Pager_btn__14gTK:hover:not(:disabled) {
  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);
}
.Pager_btn__14gTK:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.Pager_active__\\+\\+m8L {
  background: var(--dylo-orange);
  color: #fff;
}
.Pager_active__\\+\\+m8L:hover {
  background: var(--dylo-orange-hover);
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Loads/components/Pager.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yDAAyD;AAC3D;AACA;EACE,qEAAqE;AACvE;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".pager {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.btn {\n  min-width: 28px;\n  height: 28px;\n  padding: 0 6px;\n  border: none;\n  background: transparent;\n  color: var(--dylo-text);\n  font-family: var(--font-sans);\n  font-size: 13px;\n  border-radius: 7px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.12s ease, color 0.12s ease;\n}\n.btn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);\n}\n.btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.active {\n  background: var(--dylo-orange);\n  color: #fff;\n}\n.active:hover {\n  background: var(--dylo-orange-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pager": `Pager_pager__Np5BR`,
	"btn": `Pager_btn__14gTK`,
	"active": `Pager_active__++m8L`
};
export default ___CSS_LOADER_EXPORT___;
